export const AUTH_TOKEN_NAME = 'token';
export const AUTH_TOKEN_REFRESH_NAME = 'token_refresh';
export const AUTH_TOKEN_WELLFUNNEL_NAME = 'token_wellfunnel';

export enum Platform {
    iOS = 1,
    Android = 2,
    Web = 3,
}

export const PLATFORM_BY_KEY: Record<Platform, string> = {
    1: 'iOS',
    2: 'android',
    3: 'web',
};
